import React, { createContext, useContext, useEffect, useState } from "react";
import { initAnalytics } from "@/utils/analytics";

const KEY = "vila_cookie_consent_v1";
const ConsentContext = createContext({ consent: null, accept: () => {}, reject: () => {} });

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(null); // null = undecided, "accepted" | "rejected"

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (stored === "accepted" || stored === "rejected") {
      setConsent(stored);
      if (stored === "accepted") initAnalytics();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setConsent("accepted");
    initAnalytics();
  };

  const reject = () => {
    localStorage.setItem(KEY, "rejected");
    setConsent("rejected");
  };

  return (
    <ConsentContext.Provider value={{ consent, accept, reject }}>
      {children}
    </ConsentContext.Provider>
  );
}

export const useConsent = () => useContext(ConsentContext);
